import React, { useEffect, useState } from "react";
import Styles from "./GeneratorDetails.module.css";
import DriveFileRenameOutlineIcon from "@mui/icons-material/DriveFileRenameOutline";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
} from "../../../commons/Accordion";
import { useDispatch, useSelector } from "react-redux";
import { generatorDetails as generatorDetailsConfig } from "../../../commons/Profile";
import { usePdfPreview } from "../../../hooks/usePdfPreview";
import { fetchGeneratorDetails } from "../../../Redux/Slices/companyAdminSlice";

const stateData = [
  { id: 1, name: "Andhra Pradesh", label: "AP", isUt: false, regionId: 3 },
  { id: 2, name: "Arunachal Pradesh", label: "AR", isUt: false, regionId: 5 },
  { id: 3, name: "Assam", label: "AS", isUt: false, regionId: 5 },
  { id: 4, name: "Bihar", label: "BR", isUt: false, regionId: 4 },
  { id: 5, name: "Chandigarh", label: "CG", isUt: true, regionId: 1 },
  { id: 6, name: "Chhattisgarh", label: "CH", isUt: false, regionId: 2 },
  {
    id: 7,
    name: "Dadar Nagar Haveli & Daman diu",
    label: "DNH & DD",
    isUt: true,
    regionId: 2,
  },
  { id: 8, name: "Delhi", label: "DL", isUt: true, regionId: 1 },
  { id: 9, name: "DVC", label: "DVC", isUt: false, regionId: 4 },
  { id: 10, name: "Goa", label: "GA", isUt: false, regionId: 2 },
  { id: 11, name: "Gujarat", label: "GJ", isUt: false, regionId: 2 },
  { id: 12, name: "Haryana", label: "HR", isUt: false, regionId: 1 },
  { id: 13, name: "Himachal Pradesh", label: "HP", isUt: true, regionId: 1 },
  { id: 14, name: "Jammu & Kashmir", label: "JK", isUt: false, regionId: 1 },
  { id: 15, name: "Jharkhand", label: "JH", isUt: false, regionId: 4 },
  { id: 16, name: "Karnataka", label: "KA", isUt: false, regionId: 3 },
  { id: 17, name: "Kerala", label: "KL", isUt: false, regionId: 3 },
  { id: 18, name: "Madhya Pradesh", label: "MP", isUt: false, regionId: 2 },
  { id: 19, name: "Maharashtra", label: "MH", isUt: false, regionId: 2 },
  { id: 20, name: "Manipur", label: "MN", isUt: true, regionId: 5 },
  { id: 21, name: "Meghalaya", label: "ML", isUt: false, regionId: 5 },
  { id: 22, name: "Mizoram", label: "MZ", isUt: false, regionId: 5 },
  { id: 23, name: "Nagaland", label: "NL", isUt: false, regionId: 5 },
  { id: 24, name: "Odisha", label: "OD", isUt: false, regionId: 4 },
  { id: 25, name: "Puduchery", label: "PY", isUt: false, regionId: 3 },
  { id: 26, name: "Punjab", label: "PB", isUt: false, regionId: 1 },
  { id: 27, name: "Rajasthan", label: "RJ", isUt: false, regionId: 1 },
  { id: 28, name: "Sikkim", label: "SK", isUt: false, regionId: 4 },
  { id: 29, name: "Tamilnadu", label: "TN", isUt: false, regionId: 3 },
  { id: 30, name: "Telangana", label: "TS", isUt: false, regionId: 3 },
  { id: 31, name: "Tripura", label: "TR", isUt: true, regionId: 5 },
  { id: 32, name: "Uttar Pradesh", label: "UP", isUt: false, regionId: 1 },
  { id: 33, name: "Uttarakhand", label: "UK", isUt: false, regionId: 1 },
  { id: 34, name: "West Bengal", label: "WB", isUt: false, regionId: 4 },
];
const getStateName = (stateId) => {
  const state = stateData.find((state) => state.id === stateId);
  return state ? state.name : stateId;
};
const specificationData = [
  { id: 1, type: "GENERATOR", name: "Discom" },
  { id: 2, type: "GENERATOR", name: "Generator" },
  { id: 3, type: "GENERATOR", name: "IPP" },
  { id: 4, type: "GENERATOR", name: "Captive" },
  { id: 5, type: "GENERATOR", name: "Other" },
  { id: 6, type: "CONSUMER", name: "Discom" },
  { id: 7, type: "CONSUMER", name: "OA Consumer" },
  { id: 8, type: "CONSUMER", name: "Industrial" },
  { id: 9, type: "CONSUMER", name: "Other" },
];

const getSpecificationName = (specId) => {
  const spec = specificationData.find((item) => item.id === specId);
  return spec ? spec.name : specId;
};

const renderDetailElement = (
  detail,
  generatorData,
  handlePreviewGeneralTerms
) => {
  let actualValue;

  if (
    detail?.addressType === "office" &&
    generatorData?.generatorOfficeAddress
  ) {
    actualValue = generatorData.generatorOfficeAddress[detail?.value];
  } else if (
    detail?.addressType === "correspondence" &&
    generatorData?.generatorCorrespondenceAddress
  ) {
    actualValue = generatorData.generatorCorrespondenceAddress[detail?.value];
  } else if (
    detail?.addressType === "bank" &&
    generatorData?.generatorBankDetails
  ) {
    actualValue = generatorData.generatorBankDetails[detail?.value];
  } else if (
    detail?.addressType === "discom" &&
    generatorData?.discomDetails &&
    generatorData.discomDetails.length > 0
  ) {
    actualValue = generatorData.discomDetails[0][detail?.value];
  } else if (
    (detail?.value?.includes("DocId") || detail?.value?.includes("Document")) &&
    generatorData?.generatorDocuments
  ) {
    actualValue = generatorData.generatorDocuments[detail?.value];
  } else {
    actualValue = generatorData ? generatorData[detail?.value] : undefined;
  }

  const getStateName = (stateId) => {
    const state = stateData.find((state) => state.id === stateId);
    return state ? state.name : stateId;
  };

  const getSpecificationName = (specId) => {
    const spec = specificationData.find((item) => item.id === specId);
    return spec ? spec.name : specId;
  };

  let displayValue;
  if (detail?.value === "stateUtId") {
    displayValue = getStateName(actualValue);
  } else if (detail?.value === "specificationId") {
    displayValue = actualValue
      ? getSpecificationName(actualValue)
      : detail.defaultValue || "-";
  } else if (
    detail?.value === "isCommissioned" ||
    detail?.value === "isAbtExist" ||
    detail?.value === "isSubsidyReceived"
  ) {
    displayValue =
      actualValue !== undefined && actualValue !== null
        ? actualValue
          ? "Yes"
          : "No"
        : detail.defaultValue || "-";
  } else if (detail?.value === "commissionedAt" && Array.isArray(actualValue)) {
    displayValue =
      actualValue.length >= 3
        ? `${actualValue[2]}/${actualValue[1]}/${actualValue[0]}`
        : detail.defaultValue || "-";
  } else {
    displayValue =
      actualValue !== undefined &&
      actualValue !== null &&
      actualValue !== "" &&
      actualValue !== "NA"
        ? actualValue
        : detail.defaultValue || "-";
  }

  if (detail?.disp === "0") {
    return (
      <div className={Styles.eachDetailElement}>
        <div>{detail?.header}</div>
        <div>{displayValue}</div>
      </div>
    );
  }
  if (detail?.disp === "1") {
    return (
      <div className={Styles.eachDetailElement1}>
        <div>{detail?.header}</div>
        <div>{displayValue}</div>
      </div>
    );
  }
  if (detail?.disp === "2") {
   
    return (
      <div className={Styles.eachDetailElement}>
        <div>{detail?.header}</div>
        {actualValue ? (
          <div
            className={`display_flex_row_gap_8_only ${Styles.viewDoc}`}
            style={{ cursor: "pointer" }}
            onClick={() => {
             
              handlePreviewGeneralTerms(actualValue);
            }}
          >
            <span>View</span>
            <RemoveRedEyeIcon style={{ fontSize: "12px" }} />
          </div>
        ) : (
          <div>
            <span style={{ color: "#999" }}>{detail.defaultValue || "-"}</span>
          </div>
        )}
      </div>
    );
  }
  return null;
};

const renderDetailSection = (
  heading,
  details,
  generatorData,
  handlePreviewGeneralTerms
) => {
  return (
    <>
      <div className={Styles.insiderHeading}>{heading}</div>
      <div className={Styles.eachDetailElementMainContainer}>
        {details?.map((detail, idx) => (
          <React.Fragment key={idx}>
            {renderDetailElement(
              detail,
              generatorData,
              handlePreviewGeneralTerms
            )}
          </React.Fragment>
        ))}
      </div>
    </>
  );
};

const GeneratorDetails = () => {
  const dispatch = useDispatch();
  const [expanded, setExpanded] = useState("");

  // const { generators, loading, error, generatorDetail } = useSelector(
  //   (state) => state.companyAdminSlice
  // );

  const { fetchSideBarGeneratorsList, loading, error } = useSelector(
    (state) => state.CapacitySlice
  );

  const generatorDetail = useSelector((state) => state.companyAdminSlice);

  // Use the PDF preview hook
  const { handlePreviewGeneralTerms, PdfPreviewModal } = usePdfPreview();

  useEffect(() => {
    if (expanded) {
      window.scrollBy({ top: "-20px", behavior: "smooth" });
    }
  }, [expanded]);

  const handleChange = (generatorId) => {
    const isExpanding = expanded !== generatorId;
    setExpanded(expanded === generatorId ? false : generatorId);

    if (isExpanding) {
      dispatch(fetchGeneratorDetails(generatorId));
    }
  };

  const handleEdit = (e, id) => {
    e.stopPropagation();
    e.preventDefault();
    // Handle edit logic here
  };

  if (loading) {
    return (
      <div className={Styles.detailsContainer}>
        <div style={{ padding: "20px", textAlign: "center" }}>
          Loading generator details...
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className={Styles.detailsContainer}>
        <div style={{ padding: "20px", textAlign: "center", color: "red" }}>
          Error loading generator details: {error}
        </div>
      </div>
    );
  }

  if (!fetchSideBarGeneratorsList || fetchSideBarGeneratorsList.length === 0) {
    return (
      <div className={Styles.detailsContainer}>
        <div style={{ padding: "20px", textAlign: "center" }}>
          No generator details available
        </div>
      </div>
    );
  }

  return (
    <div className={Styles.detailsContainer}>
      {fetchSideBarGeneratorsList.map((generator, idx) => (
        <div
          className={Styles.eachDetailSection}
          key={generator.generatorId || idx}
        >
          <Accordion expanded={expanded === generator.generatorId}>
            <AccordionSummary
              aria-controls={`panel${generator.generatorId}d-content`}
              id={`panel${generator.generatorId}d-header`}
            >
              <div className={Styles.eachDetailSectionContainer}>
                {/* <div className={Styles.sectionHeading}>
                  <span>
                    {consumer.consumerName || consumerDetails?.heading}
                  </span>
                  <DriveFileRenameOutlineIcon
                    onClick={(e) => handleEdit(e, consumer.consumerId)}
                  />
                </div> */}
                {/* {renderDetailSection("", consumerDetails?.details, consumer)}
                {renderDetailSection(
                  "Bank Details",
                  consumerDetails?.bankDetails,
                  consumer
                )}
                {renderDetailSection(
                  "Office Address",
                  consumerDetails?.consumerOfficeAddress,
                  consumer
                )}
                {renderDetailSection(
                  "Correspondence Address",
                  consumerDetails?.consumerCorrespondenceAddress,
                  consumer
                )} */}
                {/* <div
                  className={Styles.listingDetailsBtn}
                  onClick={() => handleChange(consumer.consumerId)}
                >
                  <span>
                    {consumer.consumerName || consumerDetails?.heading} Listings
                    Activity
                  </span>
                  {expanded === consumer.consumerId ? (
                    <KeyboardDoubleArrowUpIcon style={{ fontSize: "18px" }} />
                  ) : (
                    <KeyboardDoubleArrowDownIcon style={{ fontSize: "18px" }} />
                  )}
                </div> */}
                <div
                  className={Styles.eachDetailSectionContainer}
                  onClick={() => handleChange(generator.generatorId)}
                >
                  <div className={Styles.sectionHeading}>
                    <span>
                      {generator.generatorName ||
                        generatorDetailsConfig?.heading}
                    </span>
                    {/* <DriveFileRenameOutlineIcon
                      onClick={(e) => handleEdit(e, generator.generatorId)}
                    /> */}
                  </div>
                </div>
              </div>
            </AccordionSummary>
            <AccordionDetails>
              <div className={Styles.eachDetailSectionContainer}>
                {expanded === generator.generatorId &&
                loading &&
                !generatorDetail?.generatorDetail?.data ? (
                  <div style={{ padding: "20px", textAlign: "center" }}>
                    Loading generator details...
                  </div>
                ) : expanded === generator.generatorId ? (
                  (() => {
                    const detailedData =
                      expanded === generator.generatorId &&
                      generatorDetail?.generatorDetail?.data
                        ? generatorDetail?.generatorDetail?.data
                        : generator;

                    return (
                      <>
                        {renderDetailSection(
                          "Generator Details",
                          generatorDetailsConfig?.details,
                          detailedData,
                          handlePreviewGeneralTerms
                        )}
                        {renderDetailSection(
                          "Bank Details",
                          generatorDetailsConfig?.bankDetails,
                          detailedData,
                          handlePreviewGeneralTerms
                        )}
                        {renderDetailSection(
                          "Office Address",
                          generatorDetailsConfig?.generatorOfficeAddress,
                          detailedData,
                          handlePreviewGeneralTerms
                        )}
                        {renderDetailSection(
                          "Correspondence Address",
                          generatorDetailsConfig?.generatorCorrespondenceAddress,
                          detailedData,
                          handlePreviewGeneralTerms
                        )}
                        {renderDetailSection(
                          "Discom Details",
                          generatorDetailsConfig?.discomDetails,
                          detailedData,
                          handlePreviewGeneralTerms
                        )}
                      </>
                    );
                  })()
                ) : null}
              </div>
            </AccordionDetails>
          </Accordion>
        </div>
      ))}
      {<PdfPreviewModal />}
    </div>
  );
};

export default GeneratorDetails;
